import { render, staticRenderFns } from "./thinkingQuestions.vue?vue&type=template&id=ace02d1a&scoped=true"
import script from "./thinkingQuestions.vue?vue&type=script&lang=js"
export * from "./thinkingQuestions.vue?vue&type=script&lang=js"
import style0 from "./thinkingQuestions.vue?vue&type=style&index=0&id=ace02d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace02d1a",
  null
  
)

export default component.exports